import React from 'react';
import { 
  ShieldCheck, 
  Sparkles, 
  Heart, 
  Droplets, 
  Star, 
  Zap 
} from 'lucide-react';
import { processValues } from '../data/mock';

const iconMap = {
  1: ShieldCheck,
  2: Sparkles,
  3: Heart,
  4: Droplets,
  5: Star,
  6: Zap
};

const ProcessSection = () => {
  return (
    <section id="premium" className="process-section">
      <div className="section-container">
        <div className="section-header">
          <span className="section-label">ODLIKUJE NAS</span>
          <h2 className="section-title">NAŠ PROCES – PREMIUM DOŽIVLJAJ</h2>
        </div>

        <div className="process-grid">
          {processValues.map((value) => {
            const IconComponent = iconMap[value.id];
            return (
              <div key={value.id} className="process-card">
                <div className="process-icon">
                  <IconComponent size={28} />
                </div>
                <h3 className="process-title">{value.title}</h3>
                <p className="process-description">{value.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
